const isNonProd = () => {
  const nonProdHostPatterns = [
    /local\./,
    /localhost/,
    /www\.new/,
    /\.stage/,
    /\.test/,
    /\.dev/,
    /tst\d+/,
    /dev\d+/,
    /stg\d+/,
    /-dev/,
    /-stage/,
    /-test/,
  ];
  for (let row of nonProdHostPatterns) {
    if (window.location.hostname.match(row)) {
      return true;
    }
  }
  return false;
};
export default isNonProd;
